import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Briefcase, Store } from "lucide-react";
import { api } from "@/lib/api";
import { Section, Chip } from "@/components/ui-brand";

export default function Comunidad() {
  const [feed, setFeed] = useState([]);
  useEffect(() => { api.get("/public/feed?limit=40").then((r) => setFeed(r.data.items)).catch(() => {}); }, []);

  return (
    <Section className="py-12">
      <Chip accent>Comunidad</Chip>
      <h1 className="h-section text-3xl mt-3 mb-2">El pulso de la red</h1>
      <p className="text-[var(--brand-text-muted)] mb-8 max-w-2xl">Nuevas búsquedas, emprendimientos y novedades de la comunidad Córdoba Crea Futuro.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {feed.map((f, i) => (
          <motion.div key={f.id} initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 6) * 0.05 }}
            className="card-brand p-6" data-testid={`comunidad-item-${f.id}`}>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-9 h-9 rounded-full flex items-center justify-center text-white" style={{ background: f.tipo === "busqueda" ? "var(--brand-primary)" : "var(--brand-accent)" }}>
                {f.tipo === "busqueda" ? <Briefcase size={16} /> : <Store size={16} />}
              </span>
              <Chip accent={f.tipo === "busqueda"}>{f.tipo === "busqueda" ? "Búsqueda" : "Emprendimiento"}</Chip>
            </div>
            <p className="font-heading font-bold text-[var(--brand-primary)] leading-snug">{f.titulo}</p>
            <p className="text-sm text-[var(--brand-text-muted)] mt-1">{f.detalle}</p>
            <p className="text-xs text-[var(--brand-text-muted)] mt-3">por {f.autor}</p>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
